<template>
<div class="tab_menu_ia_container">
      <TabMenu class="tab_menu_ia" :model="items_menu"/>
</div>
  <div class="h-full w-full">
    <div class="card">
      <router-view @before-enter="beforeEnter" @before-leave="beforeLeave" @update-loading="isLoading" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProduccionIA',
  data() {
    return {
      items_menu: [
        {
          label: 'Spot',
          icon: 'pi pi-fw pi-microphone',
          to: '/produccion-ia/spots',
        },
        {
          label: 'Clima',
          icon: 'pi pi-fw pi-cloud',
          to: '/produccion-ia/clima',
        },
        {
          label: 'Noticias',
          icon: 'pi pi-fw pi-book',
          to: '/produccion-ia/noticias',
          disabled: true,
        },
        {
          label: 'Efemérides',
          icon: 'pi pi-fw pi-calendar-times',
          to: '/produccion-ia/efemerides',
          disabled: true,
        },
                {
          label: 'Saludos',
          icon: 'pi pi-fw pi-user',
          to: '/produccion-ia/saludos',
          disabled: true,
        },
        {
          label: 'Accidentes',
          icon: 'pi pi-fw pi-car',
          to: '/produccion-ia/accidentes',
          disabled: true,
        },

        {
          label: 'Dólar',
          icon: 'pi pi-fw pi-dollar',
          to: '/produccion-ia/dolar',
          disabled: true,
        },
        {
          label: 'Comentar canción',
          icon: 'pi pi-fw pi-comment',
          to: '/produccion-ia/comentar-cancion',
          disabled: true,
        },
        {
          label: 'Buenos Días',
          icon: 'pi pi-fw pi-sun',
          to: '/produccion-ia/buenos-dias',
          disabled: true,
        },
      ],
    };
  },
  methods: {
    isLoading(value){
      this.$emit('update-loading', value);
    },

  },
    created() {
    console.log('Componente creado correctamente');
  },

};
</script>

<style>
.tab_menu_ia ul{
  display: flex;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  justify-content: center;
  white-space: nowrap;
  color: #fff;
}
.tab_menu_ia_container{
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 20px;
}

.tab_menu_ia{
  display: flex;
  width: 100%;
  justify-content: space-between;
  border: none;
  color: #fff;
  font-size: 1.2rem;
  font-weight: 500;
  padding: 0;
  margin: 0;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; /* Agrega puntos suspensivos al final del texto si se desborda */
}

.tab_menu_ia li{
  text-overflow: ellipsis; /* Agrega puntos suspensivos al final del texto si se desborda */
  color: #fff;

}
.in_content{
  padding: 0;
  margin: 0;
  width: 100%;
  max-width: 100% !important;
}

.p-tabmenuitem{

}
</style>
